module.exports = __webpack_public_path__ + "static/img/deliver_bg.4afae14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/deliver_bg.png
// module id = Xxpk
// module chunks = 1